import * as React from "react";
const SvgFiRrLive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-live_svg__a)">
      <path
        fill="#062147"
        d="M7 9v5h1a1 1 0 0 1 0 2H6.5c-.827 0-1.5-.673-1.5-1.5V9a1 1 0 0 1 2 0m16 1a1 1 0 1 0 0-2h-1.5c-.827 0-1.5.673-1.5 1.5v5c0 .827.673 1.5 1.5 1.5H23a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-1v-1zM10 9v6a1 1 0 0 0 2 0V9a1 1 0 0 0-2 0m-8.5 4.5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 1.5 13.5m15.552-4.816L16 11.838l-1.052-3.154a1 1 0 0 0-1.897.633l2 6a1 1 0 0 0 1.896 0l2-6a1 1 0 1 0-1.897-.633zm5.286 9.567a3 3 0 0 1-1.983.75H5c-1.654 0-3-1.346-3-3a1 1 0 0 0-2 0c0 2.757 2.243 5 5 5h15.354c1.22 0 2.395-.444 3.308-1.25a1.001 1.001 0 0 0-1.324-1.499zM1 9a1 1 0 0 0 1-1c0-1.654 1.346-3 3-3h15.354c.731 0 1.437.266 1.983.75a1 1 0 1 0 1.324-1.499 5 5 0 0 0-3.308-1.25H5A5.004 5.004 0 0 0 0 8a1 1 0 0 0 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-live_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLive;
